module.exports = __webpack_public_path__ + "static/media/icon-home.866d83c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeIcon/icon-home.svg
// module id = 1542
// module chunks = 1